angular.module('app').factory('SearchParamsService', function () {
    let fac = {
        reset: reset,
        putSearchParams: putSearchParams,
        getSearchParams: getSearchParams,
        putSearchDto: putSearchDto,
        getSearchDto: getSearchDto,
        putCriteria: putCriteria,
        getCriteria: getCriteria
    };
    let searchParams;
    let criteria;
    let searchDto;
    function reset() {
        searchDto = null;
    }
    function putSearchParams(searchParams) {
        searchParams = searchParams;
    }
    function getSearchParams() {
        return searchParams;
    }
    function putCriteria(criteria) {
        criteria = criteria;
    }
    function getCriteria() {
        return criteria;
    }
    function putSearchDto(searchDto) {
        searchDto = searchDto;
    }
    function getSearchDto() {
        return searchDto;
    }
    return fac;
});
